import { HrefLink as HrefLinkType } from '@/schemas/sceneDataSchema';
import { Link } from '@mui/material';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const HrefLink = ({ component }: { component: HrefLinkType }) => {
  const { trackEvent } = useAnalytics();

  return (
    <Link
      onClick={() => trackEvent(`${eventName(component.text)}_HREF_LINK_CLICKED`)}
      href={component.href}
      color={component.color}
      align={component.align}
      variant={component.variant}
      fontWeight={component.font_weight ?? undefined}
      target='_blank'
      rel='noopener noreferrer'
    >
      {component.text}
    </Link>
  );
};
